const FETCH_DONATE_PAGE_DATA = 'donate/FETCH_DONATE_PAGE_DATA'
const FETCH_DONATE_PAGE_DATA_SUCCESS = 'donate/FETCH_DONATE_PAGE_DATA_SUCCESS'
const FETCH_DONATE_PAGE_DATA_FAILURE = 'donate/FETCH_DONATE_PAGE_DATA_FAILURE'

export default {
  FETCH_DONATE_PAGE_DATA,
  FETCH_DONATE_PAGE_DATA_SUCCESS,
  FETCH_DONATE_PAGE_DATA_FAILURE,
}
